import { useClassified } from "@/contexts/classified";
export const useFavoriteTracking = () => {
    var _a, _b;
    const classified = useClassified();
    // For some reason, the tracking object is type "Item" and not "Event" 🤷
    const favoriteTracking = {
        id: (_a = classified === null || classified === void 0 ? void 0 : classified.id) !== null && _a !== void 0 ? _a : "",
        distribution_type: (_b = classified === null || classified === void 0 ? void 0 : classified.tracking.av_distribution_type_global) !== null && _b !== void 0 ? _b : "",
        estate_type: classified === null || classified === void 0 ? void 0 : classified.tracking.av_estate_type_global,
        list_name: "classified_detail",
    };
    return favoriteTracking;
};
